import {View} from 'pacto';
import {UTable} from '@schascha/utable/dist/utable';


export class Table extends View {

	render() {
		super.render();

		this.table = new UTable(this.el, {
			classWrapper: 'table',
			overlays: false,
			sticky: false,
			width: 'fixed',
		});

		return this;
	}

}
